import { useEffect, useRef, useState, useContext } from "react";

import useFetch from "../../../hooks/useFetch";

import Checkbox from "../../../components/Checkbox";
import Button from "../../../components/Button";
import { ReactComponent as IconArrow } from "../../../img/icons/arrow-right.svg";
import ImgPhoto from "../../../img/photos/photo1.png"

import InfosQuestionnaire from "../../InfosQuestionnaire";
import SimulationContext from "../../../contexts/Simulation";
import useTrackEvent from "../../../hooks/useTrackEvent";

const Popup = ({ setOpen, setContactId, setOpportunityId }) => {
  const [doPushLead, responsePushLead, isLoading, pushLeadError] = useFetch(
    `${process.env.REACT_APP_API_URL}?action=artyseo_lead`
  );

  const [simParams, setSimParams] = useContext(SimulationContext);
  const [boxChecked, setBoxChecked] = useState(false);
  const [newsChecked, setNewsChecked] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [firstname, setFirstname] = useState(null);
  const [lastname, setLastname] = useState(null);
  const [email, setEmail] = useState(null);
  const [tel, setTel] = useState(null);
  const firstnameRef = useRef(null);
  const lastnameRef = useRef(null);
  const emailRef = useRef(null);
  const telRef = useRef(null);
  const trackEvent = useTrackEvent();

  const toggleCheckbox = () => {
    setBoxChecked(!boxChecked);
  }

  const toggleNewsCheckbox = () => {
    setNewsChecked(!newsChecked);
  }

  const submitForm = () => {
    if (formValid)
    {
      const infos = {};
      InfosQuestionnaire.forEach((e) => {
        infos[e.title] = simParams.infos[e.key] instanceof Array ? 
          simParams.infos[e.key].join(', ') : 
          simParams.infos[e.key];
      });
      setSimParams({
        ...simParams, 
        contact: {
          firstname,
          lastname,
          email,
          tel
        },
        video_play: true
      });
      const pushLeadOptions = {
        method: 'POST',
        body: JSON.stringify({
          firstname: firstname,
          lastname: lastname,
          email: email,
          tel: tel,
          address: simParams.location.components,
          infos: infos,
          newsletter: newsChecked
        }),
      };
      doPushLead(pushLeadOptions);
    }
  }

  useEffect(() => {
    if (responsePushLead)
    {
      setContactId(responsePushLead.cid);
      setOpportunityId(responsePushLead.oid)
      setOpen(false);
      trackEvent('lead_submitted', {
        lead_email: email || null,
        lead_phone: tel || null
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responsePushLead]);

  useEffect(() => {
    if (pushLeadError)
      setOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pushLeadError]);
 
  const validateForm = () => {
    setFormValid(firstnameRef.current.checkValidity() && 
                 lastnameRef.current.checkValidity() &&
                 emailRef.current.checkValidity() &&
                 telRef.current.checkValidity() &&
                 boxChecked);
  }

  useEffect(() => {
    if (!firstname || !lastname || !email || !tel) return;
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstname, lastname, email, tel, boxChecked])

  return (
    <div className="overlay">
      <div className="popup">
        <div className="title">Oui je veux recevoir mon étude 😍 sans engagement !</div>
        <div className="field">
          <label>Nom</label>
          <input type="text" name="nom" ref={lastnameRef} onChange={e => setLastname(e.target.value)} required/>
        </div>
        <div className="field">
          <label>Prénom</label>
          <input type="text" name="prenom" ref={firstnameRef} onChange={e => setFirstname(e.target.value)} required/>
        </div>
        <div className="field">
          <label>Email</label>
          <input type="email" name="email" ref={emailRef} onChange={e => setEmail(e.target.value)} required/>
        </div>
        <div className="field">
          <label>Téléphone</label>
          <input type="text" name="tel" ref={telRef} onChange={e => setTel(e.target.value)} required pattern="^[0-9]{10}$"/>
        </div>
        <Checkbox set_checked={ toggleCheckbox } checked={ boxChecked }>En cochant cette case, je reconnais avoir pris connaissance des conditions générales d’utilisation, de la politique de confidentialité d’Artyseo et je les accepte. Simulation selon les modalités prévues aux conditions générales d’utilisation.</Checkbox>
        <div className="prow">
          <Checkbox set_checked={ toggleNewsCheckbox } checked={ newsChecked }><b>Inscription newsletter</b> - Oui, je veux recevoir les idées solaires d’Artyseo ☀. ️Des conseils malins, des actus sur l’énergie solaire et une bonne dose d’inspiration pour faire briller ma maison (sans spam, promis ✋).</Checkbox>
          <Button IconAfter={IconArrow} variant={((formValid && !isLoading) ? '' : ' outlined thin light')} onclick={submitForm}>Découvrez vite vos résultats</Button>
        </div>
        <div className="reassu">
          <img src={ImgPhoto} alt=""/>
          <span className="text">
            <div class="rtitle">Pas d'arnaque, pas de spam !</div>
            Chez Artyseo, on aime le soleil… pas la revente de données.<br/>
            🌞 Vos infos restent bien au chaud et ne servent qu'à réaliser votre étude solaire.<br/>
            <b>📞 Un numéro de téléphone valide est essentiel pour que nous puissions vous transmettre vos résultats et répondre à vos questions.</b>
          </span>
        </div>
      </div>
    </div>
  )
};

export default Popup;